import { z } from "zod/mini"

const GeoPointConfigSchema = z.object({
	label: z.nullish(z.string()),
})

export const GeoPointModelSchema = z.object({
	type: z.literal("GeoPoint"),
	fieldset: z.nullish(z.string()),
	config: z.optional(GeoPointConfigSchema),
})

export type GeoPointModel = z.infer<typeof GeoPointModelSchema>
